

const IndexInvestorActivitiesItemSchema = {
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default IndexInvestorActivitiesItemSchema
